var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`${_vm.carbonPrefix}--form-item`},[_c('cv-skeleton-text',{attrs:{"heading":"","width":"100px"}}),_c('cv-skeleton-text',{class:`${_vm.carbonPrefix}--label-description`,attrs:{"width":"225px"}}),_c('cv-button-skeleton')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }